import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

type Props = {
    page: number;
    onPageChange?: (page: number) => void;
    totalPages: number;
}

const PageSelector = ({
    page,
    onPageChange,
    totalPages
}: Props) => {
    const [value, setValue] = useState(page + 1);
    const [error, setError] = useState(false);

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value);
        setValue(value);

        if (Number.isNaN(value)) {
            setError(true);
        }
        else if (value > totalPages) {
            setError(true);
        } else if (value <= 0) {
            setError(true);
        } else {
            setError(false);
        }
    }

    const handleSubmit = () => {
        setError(false);
        if (error) {
            setValue(page + 1);
            return;
        }
        const newPage = value - 1;
        if (newPage === page) {
            return;
        }
        onPageChange && onPageChange(newPage);
    }

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter') {
            return;
        }

        handleSubmit();
    }

    useEffect(() => {
        setValue(page + 1);
    }, [page]);

    const classes = useStyles();

    return (
        <span className={classes.wrapper}>
            <Typography component="span" variant='body2'>
                Page
            </Typography>
            <input
              className={classes.input}
              value={value}
              type="number"
              onBlur={handleSubmit}
              onChange={handleValueChange}
              onKeyPress={handleKeyPress}
              onFocus={(e) => e.target.select()}
              id="pageNumber"
            />
            <Typography component="span" variant='body2'>
                of {totalPages}
            </Typography>
        </span>
    )
}

const useStyles = makeStyles<Theme>((theme) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    input: {
        marginTop: `${theme.spacing(0.5)} !important`,
        width: 70,
        fontSize: 16,
        padding: '4px 0 3px',
        border: 'none',
        borderBottom: '1px solid rgba(0,0,0,0.42)',
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
        },
        "&[type=number]": {
            "-moz-appearance": "textfield",
        },
        '&:focus': {
            outline: 'none',
            borderBottom: '2px solid #3f51b5',
        },
        '&:hover': {
            borderBottom: '2px solid rgba(0,0,0,0.87)',
        },
    }
}));

export default PageSelector;
